// Corner radii — matches the design handoff prototype (rounded surfaces):
//   buttons / inputs / chips 6 · nav item / logo 7 · secondary chips 8 · cards 10 ·
//   modals / funnel 12 · pills & bars 999 · avatars 50% (use `full`).
// Legacy r1..r5 keys are retained (mapped onto the scale) so existing call sites
// keep working; prefer the semantic aliases (sm/md/lg/xl/pill) in new code.
export const Radii = {
  // semantic scale
  sm:   6,   // buttons, inputs, chips
  md:   8,   // secondary chips, small cards
  lg:   10,  // cards
  xl:   12,  // modals, funnel
  pill: 999, // pills, progress bars, dots

  // legacy aliases (kept for backward-compat; do not extend)
  r1:   6,
  r2:   8,
  r3:   10,
  r4:   12,
  r5:   14,
  full: 999,
};
